import { Box } from '@mui/material';
import React from 'react';

import { useScope } from '@sophocles/app';
import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';
import useRelayLoadTerm from '@sophocles/hooks/useRelayLoadTerm';

import PlantRelayLoadsGrid from './components/PlantRelayLoadsGrid';

function PlantRelayLoadsReportView(props) {
  const {
    match: { params },
  } = props;

  const { customer } = useScope();
  const isBillboard = customer?.is_billboard ?? false;
  const siteGroupId = Number(params.sitegroup_id);
  const { singular: relayLoadTerm } = useRelayLoadTerm(
    isBillboard
      ? { singularKey: 'reports.panel', pluralKey: 'reports.panels' }
      : { singularKey: 'reports.zone', pluralKey: 'reports.zones' },
  );

  return (
    <AppNav flex notFullHeight page="plant" {...props}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
          padding: '0 var(--page-px) var(--page-py)',
        }}
      >
        <TitleBar showBackButton title={`${relayLoadTerm} Illumination Schedules Report`} />
        <PlantRelayLoadsGrid siteGroupId={siteGroupId} isBillboard={isBillboard} />
      </Box>
    </AppNav>
  );
}

export default PlantRelayLoadsReportView;
